module.exports = __webpack_public_path__ + "img/data.3022c09c.png";